import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateTimeFormatRounding'
})
export class DateTimeFormatRoundingPipe implements PipeTransform {
  transform(rounding: number = 0): 'dd.MM.yyyy' | 'dd.MM.yyyy HH' | 'dd.MM.yyyy HH:mm' | 'dd.MM.yyyy HH:mm:ss' {
    if (rounding == 0) {
      return 'dd.MM.yyyy';
    }
    if (rounding == 1) {
      return 'dd.MM.yyyy HH';
    }
    if (rounding == 2) {
      return 'dd.MM.yyyy HH:mm';
    }
    if (rounding == 3) {
      return 'dd.MM.yyyy HH:mm:ss';
    }
  }
}
